import {
  CrmScoringState,
  CrmScoringAction,
  SET_AXIS,
  SET_DATE_RANGE,
  SET_MATRIX_LOADING,
  SET_MATRIX,
  TOGGLE_CELL,
  CLEAR_SELECTED_CELLS,
  SET_USERS_LOADING,
  SET_USERS,
  SET_USERS_PAGE,
  SET_USERS_PER_PAGE,
  SET_SORT,
  SET_SNAPSHOT_DATE,
  SET_SEARCH_QUERY,
  SET_CHECKED_USERS,
} from '../actions/crmScoring'

// ローカルタイムゾーンのYYYY-MM-DDを返す (toISOStringはUTCなので日付がずれる)
const toLocalDateString = (d: Date): string => d.toLocaleDateString('sv-SE')
const yesterday = (): string => {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  return toLocalDateString(d)
}
const twoYearsBeforeYesterday = (): string => {
  const d = new Date()
  d.setDate(d.getDate() - 1)
  d.setFullYear(d.getFullYear() - 2)
  return toLocalDateString(d)
}

const initialState: CrmScoringState = {
  axis: 'f2_m2',
  dateRange: { start: twoYearsBeforeYesterday(), end: yesterday() },
  matrix: { total: 0, cells: [], loading: false },
  selectedCells: [],
  users: { items: [], total: 0, page: 1, perPage: 50, loading: false },
  sort: { sortBy: 'from_max_date', sortOrder: 'desc' },
  // 集計時点(YYYY-MM-DD): 初期値は今日(=その前日までのデータが集計済)
  snapshotDate: toLocalDateString(new Date()),
  searchQuery: '',
  checkedUserIds: [],
}

export default function crmScoringReducer(
  state: CrmScoringState = initialState,
  action: CrmScoringAction,
): CrmScoringState {
  switch (action.type) {
    case SET_AXIS:
      return { ...state, axis: action.axis, selectedCells: [], checkedUserIds: [] }
    case SET_DATE_RANGE:
      // 期間変更時はページを1に戻す (範囲外ページのままだと 0 件表示になる)
      return { ...state, dateRange: { start: action.start, end: action.end }, users: { ...state.users, page: 1 } }
    case SET_MATRIX_LOADING:
      return { ...state, matrix: { ...state.matrix, loading: action.loading } }
    case SET_MATRIX:
      return { ...state, matrix: { total: action.total, cells: action.cells, loading: false } }
    case TOGGLE_CELL: {
      const { x, y } = action
      const idx = state.selectedCells.findIndex(([cx, cy]) => cx === x && cy === y)
      const next: Array<[number, number]> =
        idx >= 0
          ? state.selectedCells.filter((_, i) => i !== idx)
          : [...state.selectedCells, [x, y]]
      // セル選択の変更時はページを1に戻す (範囲外ページのままだと 0 件表示になる)
      return { ...state, selectedCells: next, users: { ...state.users, page: 1 } }
    }
    case CLEAR_SELECTED_CELLS:
      // 選択解除時もページを1に戻す
      return { ...state, selectedCells: [], checkedUserIds: [], users: { ...state.users, page: 1 } }
    case SET_USERS_LOADING:
      return { ...state, users: { ...state.users, loading: action.loading } }
    case SET_USERS:
      return {
        ...state,
        users: {
          items: action.items,
          total: action.total,
          page: action.page,
          perPage: action.perPage,
          loading: false,
        },
      }
    case SET_USERS_PAGE:
      return { ...state, users: { ...state.users, page: action.page } }
    case SET_USERS_PER_PAGE:
      // 表示件数変更時はページを1に戻す
      return { ...state, users: { ...state.users, perPage: action.perPage, page: 1 } }
    case SET_SORT:
      // ソート条件変更時はページを1に戻す
      return { ...state, sort: { sortBy: action.sortBy, sortOrder: action.sortOrder }, users: { ...state.users, page: 1 } }
    case SET_SNAPSHOT_DATE:
      // 集計時点変更時はページ・選択セルもリセット
      return { ...state, snapshotDate: action.snapshotDate, users: { ...state.users, page: 1 }, selectedCells: [], checkedUserIds: [] }
    case SET_SEARCH_QUERY:
      // 検索文字列変更時はページを1に戻す
      return { ...state, searchQuery: action.query, users: { ...state.users, page: 1 } }
    case SET_CHECKED_USERS:
      return { ...state, checkedUserIds: action.ids }
    default:
      return state
  }
}
